import { create } from "zustand";

export const useRecordStore = create((set) => ({
  fields: [],
  currentPage: 0,
  currentPageSize: 0,
  currentSorting: [],
  currentFilter: "",
  currentRecord: 0,
  selectedTags: [],
  tagOperation: "OR",
  selectedVersion: [],
  storedCurrentVersion: null,
  currentListItems: [],

  setFields: (fields) => set({ fields }),
  setCurrentPage: (page) => set({ currentPage: page }),
  setCurrentPageSize: (pageSize) => set({ currentPageSize: pageSize }),
  setCurrentSorting: (sorting) => set({ currentSorting: sorting }),
  setCurrentFilter: (filter) => set({ currentFilter: filter }),
  setCurrentRecord: (record) => set({ currentRecord: record }),
  setSelectedTags: (tags) => set({ selectedTags: tags }),
  setTagOperation: (op) => set({ tagOperation: op }),
  setSelectedVersions: (versions) => set({ selectedVersion: versions }),
  setStoredCurrentVersion: (version) => set({ storedCurrentVersion: version }),
  setCurrentListItems: (items) => set({ currentListItems: items }),
}));
